import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'
import HowServicesWorkSection from '@/v2/components/sections/snowboard-shipping/how-services-work-section'

import {
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  howServiceWorksSectionContent,
  prohibitedItemsSectionContent,
  promotionalBannerSectionContent,
  typesOfSportsSectionContent,
  whyProperSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/sport-gear-storage-page'

interface SportGearStoragePageProps {}

const SportGearStoragePage: React.FC<SportGearStoragePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
      w-[324px] h-[218px] 
      md-mn:w-[380px] md-mn:h-[286px] 
      lg:!w-[448px] lg:!h-[313px] 
      xl-min:!w-[680px] xl-min:!h-[458px]
      [&_p]:text-pretty
      '
        btnClassName='md-mn:w-[301px] w-[262px] h-[44px]'
      />
      <WhyWeSection
        isBgDark
        {...whyWeSectionContent}
        sectionTitleClassName='xl-min:!w-full lg-mn:w-[65%] md-mn:w-[90%] w-[95%]'
      />
      <HelperSection
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        className='xl-min:[&_button]:!w-[365px] [&_button]:!w-[326px]'
      />
      <HelperSection
        isBgDark
        {...whyProperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        className={`
            [&_ul]:space-y-3
            xl-min:[&>div>div:last-of-type>div]:!flex-row-reverse
            [&>div>div:last-of-type>div]:flex-col
            xl-min:[&_button]:!w-[257px]
            [&_button]:w-[236px]
            `}
        sectionTitleClassName='xl-min:[&_p]:!w-[885px] lg-mn:[&_p]:w-[80%] [&_p]:w-[90%]'
      />
      <HelperSection
        {...typesOfSportsSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[350px] md-mn:h-[252px] w-[350px] h-[196px]'
        className='
            xl-min:[&_button]:!w-[365px] 
            [&_button]:!w-[326px]
            md-mn:[&>div>div:last-of-type>div]:!flex-row
            [&>div>div:last-of-type>div]:flex-col
        '
        sectionTitleClassName='lg-mn:[&_p]:w-[685px] [&_p]:w-[90%] md-mn:[&_h2]:w-full [&_h2]:w-[80%]'
      />
      <HowServicesWorkSection
        isBgDark
        {...howServiceWorksSectionContent}
        className={`
        md-mn:[&_button]:w-[278px]
        [&_button]:w-[244px]
        `}
        sectionTitleClassName='w-full'
        imgClassName='xl-min:w-[737px] xl-min:h-[548px] lg-mn:w-[751px] lg-mn:h-[500px]'
      />
      <HelperSection
        {...prohibitedItemsSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:h-[252px] w-[350px] h-[196px]'
        className={`
          [&_ul]:space-y-3
          md-mn:[&>div>div:last-of-type>div]:!flex-row-reverse
          [&>div>div:last-of-type>div]:flex-col
          [&_li:last-of-type]:list-none
          [&_li:last-of-type]:-ml-7
          xl-min:[&_li:last-of-type]:!mt-6
          [&_li:last-of-type]:!mt-3
          `}
        sectionTitleClassName='lg-mn:w-full w-[80%]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
            [&_h3]:w-[90%]
            xl-min:[&_button]:!w-[281px]
            lg-mn:[&_button]:w-[236px]
            md-mn:[&_button]:w-[229px]
            [&_button]:w-[280px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default SportGearStoragePage
